import { createSlice } from "@reduxjs/toolkit";
import { ANALYTICS_TIMEFRAME } from "../data/publisher.data";
import { set } from "lodash";

export const DEFAULT_PAGING = {
  page: 0,
  pageSize: 20,
};

export const DEFAULT_SORT_MODEL = [{ field: "email", sort: "asc" }];

// "publisherId": 1122,
// "publisherName": "The Economist",
// "publisherRole": "PublisherAdmin",
// "roles": [
//     "PublisherAdmin"
// ],

export const publisherSlice = createSlice({
  name: "publisher",
  initialState: {
    analyticsTimeframe: 3,
    periodTimeFrame: 3,
    publisherId: null,
    publisherName: "",
    publisherRole: "",
    roles: [],
    publisherDetails: [],
  },
  reducers: {
    setAnalyticsTimeframe(state, action) {
      const { payload } = action;
      state.analyticsTimeframe = payload;
    },
    setPeriodTimeFrame(state, action) {
      const { payload } = action;
      state.periodTimeFrame = payload;
    },
    setPublisherId(state, action) {
      const { payload } = action;
      state.publisherId = payload;
    },
    setPublisherName(state, action) {
      const { payload } = action;
      state.publisherName = payload;
    },
    setPublisherRole(state, action) {
      const { payload } = action;
      state.publisherRole = payload;
    },
    setRoles(state, action) {
      const { payload } = action;
      state.roles = payload;
    },
    setPublisherDetails(state, action) {
      const { payload } = action;
      state.publisherDetails = payload;
    },
  },
});

export const {
  setAnalyticsTimeframe,
  setPeriodTimeFrame,
  setPublisherId,
  setPublisherName,
  setPublisherRole,
  setRoles,
  setPublisherDetails,
} = publisherSlice.actions;

export const publisherReducer = publisherSlice.reducer;
